export default __webpack_public_path__ + "static/media/downOxxo.f263ae65.svg";